/**
 * @generated SignedSource<<be1d8699af11e13d37dec33b525fb535>>
 * @relayHash 07154732cd6de9c83b93caf7e4fdb17b
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 07154732cd6de9c83b93caf7e4fdb17b

import type { ConcreteRequest } from 'relay-runtime';
export type DeleteIssueFieldValueInput = {
  clientMutationId?: string | null | undefined;
  fieldId: string;
  issueId: string;
};
export type deleteIssueFieldValueMutation$variables = {
  input: DeleteIssueFieldValueInput;
};
export type deleteIssueFieldValueMutation$data = {
  readonly deleteIssueFieldValue: {
    readonly issue: {
      readonly id: string;
    } | null | undefined;
    readonly success: boolean | null | undefined;
  } | null | undefined;
};
export type deleteIssueFieldValueMutation = {
  response: deleteIssueFieldValueMutation$data;
  variables: deleteIssueFieldValueMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteIssueFieldValuePayload",
    "kind": "LinkedField",
    "name": "deleteIssueFieldValue",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Issue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteIssueFieldValueMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "deleteIssueFieldValueMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "07154732cd6de9c83b93caf7e4fdb17b",
    "metadata": {},
    "name": "deleteIssueFieldValueMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "ade9c121a42280fa29046520cd641e3c";

export default node;
